import React from "react";
import HOC from "../../components/HOC";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import AddDiscount from "../../components/screen/discount/AddDiscount";

const Discount = ({ isDetail }) => {
  return (
    <div className="">
      <PageTemplate
        header={`${isDetail ? "Detail" : "Add New"} Promo`}
        mainComponent={<AddDiscount isDetail={isDetail ? isDetail : false} />}
        pageRole={0}
      />
    </div>
  );
};

export default HOC(Discount);
